import Vue from 'vue'
import Vuex from 'vuex'
import pubFunction from '../public/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		leftNav: [],
		hasLogin: false,
		token: '',
		realStatus:true,
		userInfo:{}
	},
	mutations: {
		login(state, token) {
			state.hasLogin = true;
			state.token = token
			pubFunction.setStorage('i_token', token)
		},
		logout(state) {
			state.hasLogin = false;
			state.token = ''
			state.leftNav = []
			localStorage.clear()
			pubFunction.routerToLogin()
		},
		saveUserinfo(state, userInfo) {
			pubFunction.setStorage('i_userInfo', JSON.stringify(userInfo))
		},
		setRealStatus(state, userInfo){
			let realStatus = parseInt(userInfo.realStatus)
			state.userInfo = userInfo
			state.realStatus = realStatus==0?false:true;
		},
		saveRouter(state, router){
			state.leftNav = router
		}
	},
	actions: {},
	modules: {}
})
